
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiLivelliGrid extends Serenity.EntityGrid<ProdottiLivelliRow, any> {
        protected getColumnsKey() { return ProdottiLivelliColumns.columnsKey; }
        protected getDialogType() { return ProdottiLivelliDialog; }
        protected getIdProperty() { return ProdottiLivelliRow.idProperty; }
        protected getInsertPermission() { return ProdottiLivelliRow.insertPermission; }
        protected getLocalTextPrefix() { return ProdottiLivelliRow.localTextPrefix; }
        protected getService() { return ProdottiLivelliService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}